import SpinnerStyle from './Spinner.module.css';

const Spinner = ({ className }) => {
	return (
		<div className={`${SpinnerStyle.loader} ${className}`}>Loading...</div>
	);
};

export default Spinner;
